import { render } from "./ModalUpsellItems.vue?vue&type=template&id=67bc8ad7&scoped=true"
import script from "./ModalUpsellItems.vue?vue&type=script&lang=js"
export * from "./ModalUpsellItems.vue?vue&type=script&lang=js"

import "./ModalUpsellItems.vue?vue&type=style&index=0&id=67bc8ad7&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bc8ad7"]])

export default __exports__